import { Clock, ListOrdered, Mail, Phone } from 'lucide-react'

import { cn } from '@/lib/utils'
import { type Recommendation, RecommendationAction, RecommendationPriority } from '@/models/workQueue'

const priorityColors: Record<RecommendationPriority, string> = {
  [RecommendationPriority.HIGH]: 'bg-red-100 text-red-800',
  [RecommendationPriority.MEDIUM]: 'bg-amber-100 text-amber-800',
  [RecommendationPriority.LOW]: 'bg-slate-100 text-slate-700',
}

const actionIcon: Record<RecommendationAction, typeof Mail> = {
  [RecommendationAction.EMAIL]: Mail,
  [RecommendationAction.CALL]: Phone,
  [RecommendationAction.SEQUENCE]: ListOrdered,
  [RecommendationAction.STATUS_CHANGE]: Clock,
}

const actionLabel: Record<RecommendationAction, string> = {
  [RecommendationAction.EMAIL]: 'Send email',
  [RecommendationAction.CALL]: 'Call',
  [RecommendationAction.SEQUENCE]: 'Start sequence',
  [RecommendationAction.STATUS_CHANGE]: 'Update status',
}

export function NextBestActionSection({ recommendation }: { recommendation: Recommendation | null }) {
  if (!recommendation) {
    return <p className="text-muted-foreground text-sm">No recommendation yet — generated nightly.</p>
  }
  const ActionIcon = actionIcon[recommendation.action]
  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-center gap-2">
        <ActionIcon className="size-4 shrink-0" />
        <span className="font-medium">{actionLabel[recommendation.action]}</span>
        <span
          className={cn(
            'ml-auto rounded px-1.5 py-0.5 text-xs font-medium',
            priorityColors[recommendation.priority]
          )}
        >
          {recommendation.priority}
        </span>
      </div>
      <p className="text-muted-foreground">{recommendation.reasoning}</p>
    </div>
  )
}
